import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function RealEstateLaw() {

  useEffect(() => {
    document.title = "Real Estate Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="./realstate.jpg" 
              alt="Real Estate Law" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              It covers various aspects of property ownership, transactions, and disputes. At Legal Trails, we offer comprehensive legal services designed to meet the diverse needs of our clients in the real estate sector. Our expertise includes drafting and reviewing purchase agreements, sale contracts, and lease agreements, as well as providing assistance in buying, selling, and leasing properties. We also offer legal guidance on land use and zoning regulations, ensuring compliance with property development projects. Additionally, we represent clients in disputes involving real estate transactions, boundary conflicts, and property rights. Our team is committed to advising clients on compliance with local, state, and federal regulations, helping them navigate the complexities of real estate law with confidence.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default RealEstateLaw;
